import React, { Component } from 'react';
import {NotificationContainer} from 'react-notifications';
import SigninotpBox from './auth/Signinotp';
import { Link } from 'react-router-dom';
import OrganicDivider from './utils/OrganicDivider';
import './SigninTheme.css';


class Signin extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="ps-account ps-auth-page nw-signin">
                <div className="container nw-signin__container">
                    <Link className="nw-signin__back" to="/"><span aria-hidden="true">←</span> Back to shopping</Link>
                    <div className="nw-signin__layout">
                        <aside className="nw-signin__story" aria-label="Nature Way" style={{'--signin-pattern': "url('/assets/img/home-ingredients-pattern.svg')"}}>
                            <span className="nw-signin__eyebrow">Rooted in tradition</span>
                            <h2>From our roots,<br /><span>to your home.</span></h2>
                            <OrganicDivider />
                            <p>Traditional oils, familiar ingredients, and everyday favourites for your kitchen.</p>
                            <svg className="nw-signin__illustration" viewBox="0 0 340 220" fill="none" aria-hidden="true" focusable="false">
                                <circle cx="175" cy="112" r="88" fill="#eee3ca" />
                                <circle cx="175" cy="112" r="98" stroke="#d5c4a0" strokeDasharray="2 8" />
                                <ellipse cx="173" cy="202" rx="118" ry="7" fill="#dfd2b6" />
                                <path d="M135 47h36v29c0 9 20 18 20 32v79c0 8-5 12-13 12h-52c-8 0-13-4-13-12v-79c0-14 22-23 22-32V47Z" fill="#e0b960" stroke="#a78042" strokeWidth="1.5" />
                                <path d="M119 116c22-5 43 5 66 0v70c0 5-3 7-8 7h-50c-5 0-8-2-8-7v-70Z" fill="#c5963a" />
                                <path d="M125 101v79" stroke="#fff0c5" strokeWidth="3" strokeLinecap="round" opacity=".7" />
                                <rect x="130" y="35" width="47" height="20" rx="4" fill="#244b35" />
                                <path d="M138 39v12m8-12v12m8-12v12m8-12v12m8-12v12" stroke="#718465" />
                                <rect x="122" y="130" width="60" height="44" rx="4" fill="#244b35" />
                                <path d="M152 137c-2 6-10 11-10 18a10 10 0 0 0 20 0c0-7-8-12-10-18Z" fill="#e5c47a" />
                                <path d="M215 88h23v21c0 7 14 13 14 23v58c0 6-3 9-9 9h-33c-6 0-9-3-9-9v-58c0-10 14-16 14-23V88Z" fill="#c4aa70" stroke="#957449" strokeWidth="1.5" />
                                <rect x="212" y="77" width="29" height="17" rx="3" fill="#684b32" />
                                <rect x="208" y="145" width="37" height="31" rx="3" fill="#f6f0df" stroke="#ad925c" />
                                <path d="M225 168v-14m0 8c-8 0-10-6-9-9 7 0 10 4 9 9Zm1-3c0-7 4-10 10-10 0 7-5 10-10 10Z" stroke="#597247" strokeWidth="1.4" strokeLinejoin="round" />
                                <path d="M55 188c14-17 27-37 39-63m-24 46c-20 0-25-12-22-20 14 0 24 8 22 20Zm13-23c-3-15 3-26 17-30 4 14-2 25-17 30Zm-24 38c-15 5-24 1-28-9 13-7 24-6 28 9Z" stroke="#7a8a5e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M278 164c12-10 23-10 24-2 0 6-5 11-11 15-8 4-20 3-21-3-1-4 3-7 8-10Z" fill="#d4b58a" stroke="#a88155" />
                                <path d="m278 164 13 13m-15-7 19-6" stroke="#a88155" strokeWidth=".8" />
                            </svg>
                            <span className="nw-signin__story-note">Your favourites. Your orders. All in one place.</span>
                        </aside>
                        <section className="nw-signin__form" aria-labelledby="signin-title">
                                <header className="nw-signin__header">
                                    <span className="nw-signin__eyebrow">Your Nature Way account</span>
                                    <h1 id="signin-title">A warm <span>welcome.</span></h1>
                                    <p>Sign in with your mobile number. No password to remember.</p>
                                </header>
                                {new URLSearchParams(this.props.location?.search || '').get('reason') === 'expired' ? (
                                    <p role="alert" className="nw-signin__expired">
                                        Your session has expired. Please sign in again to continue.
                                    </p>
                                ) : null}
                                <SigninotpBox {...this.props} />
                                <p className="nw-signin__new-account">New here? Your account is created after mobile verification.</p>
                                <div className="nw-signin__links"><Link to="/terms">Terms &amp; Conditions</Link><span aria-hidden="true">·</span><Link to="/privacypolicy">Privacy Policy</Link><Link className="nw-signin__help" to="/contactus">Need help?</Link></div>
                        </section>
                    </div>
                </div>
                <NotificationContainer />
            </div>
        );
    }
}

export default Signin;
